import * as React from "react";
import useFeature from "hooks/useFeature";
import ModelProviderConfigPage from "ai-management/ModelProviderConfigPage";
import { AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG } from "ai-management/Constants";
import ModelProvidersOverviewPage from "./ModelProvidersOverviewPage";
const ModelProvidersPage = () => useFeature(AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG) ? /* @__PURE__ */ React.createElement(ModelProvidersOverviewPage, null) : /* @__PURE__ */ React.createElement(ModelProviderConfigPage, null);
export default ModelProvidersPage;
